<template>
  <v-app>
    <loading :active.sync="busy"/>
    <div class="container">

      <!-- Contents -->
      <div class="contents" v-if="success">
        <div class="header-title">
          <div>결제 정보가</div>
          <div>업데이트 되었습니다.</div>
        </div>
        <div class="header-subtitle">
          아래 확인 버튼을 눌러 이전 화면으로 돌아가 변경 내용을 확인하세요.
        </div>
        <div class="actions">
          <v-btn block depressed @click="close"
            color="primary">
            {{ $t('actions.confirm') }}
          </v-btn>
        </div>
      </div>

      <div class="contents" v-else-if="error">
        <div class="header-title">
          <div>결제 정보 업데이트 중</div>
          <div>오류가 발생했습니다.</div>
        </div>
        <div class="header-subtitle">
          아래 확인 버튼을 눌러 다시 시도해주시기 바랍니다.
        </div>
        <div class="actions">
          <v-btn block depressed @click="close"
            color="primary">
            {{ $t('actions.confirm') }}
          </v-btn>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      busy: false,
      success: false,
      error: false,
    }
  },

  computed: {
    order_no() {
      return this.$route.query.order_no
    },
  },

  async created() {
    this.busy = true
    try {
      await this.$store.dispatch('payment/returnUpdatePayletter', {
        order_no: this.order_no,
      })
    } catch(e) {
      this.error = true
    } finally {
      if (!this.error) {
        this.success = true
      }
      this.busy = false
    }
  },

  methods: {
    close() {
      window.close()
    },
  },
}
</script>

<style scoped>
  .container {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contents {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    max-width: 450px;
    width: 100%;
    padding: 22px 40px 38px;
    margin-top: 60px;
  }

  .header-title {
    padding: 20px 0;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .header-subtitle {
    padding-bottom: 20px;
    font-size: 16px;
    text-align: center;
    color: #676168;
  }
</style>


// WEBPACK FOOTER //
// src/components/spa/common/UpdatePayment.vue